import React, { FunctionComponent } from 'react';

import cls from 'classnames';
import { Link } from 'react-router-dom';

import sightXLogo from '../../../../assets/sightxLogoWhiteWithRepdata.svg';
import netquestLogo from '../../../../assets/netquest/Flash-Survey-Logo-White.svg';
import pureProfileLogo from '../../../../assets/pureprofile/logo-for-dark-bg.png';
import { isNetquestClient, isPureProfileClient } from '../../../../utils/clients';

import styles from './logo.module.scss';

const renderLogo = (style: string, logo: string, alt: string) => (
  <Link to="/">
    <img className={style} src={logo} alt={alt} />
    <div className={styles.powerBySightX}>
      <span className={styles.label}>Powered by</span>
      <img className={styles.miniLogo} src={sightXLogo} alt="SightX Logo" />
    </div>
  </Link>
);
export const Logo: FunctionComponent = () => {
  const isNetquest = isNetquestClient();
  const isPureProfile = isPureProfileClient();
  if (isPureProfile) {
    return <div className={cls(styles.container, styles.pureprofile)}>
      {renderLogo(styles.pureProfileLogo, pureProfileLogo, 'Pureprofile Logo')}
    </div>;
  }
  if (isNetquest) {
    return <div className={cls(styles.container, styles.netquest)}>
      {renderLogo(styles.logo, netquestLogo, 'Netquest Logo')}
    </div>;
  }
  return <div className={cls(styles.container, styles.sightx)}>
    <Link to="/">
      <img className={styles.logo} src={sightXLogo} alt="SightX Logo" />
    </Link>
  </div>;
};

